import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/simple-past-explanation';

const mainimage = '/Images/simplepast1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "simplepast" },
];

const SimplePast = () => (
  <GrammarPageLayout
    level="A2"
    title="Simple Past"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Simple Past Exercises"
    seoDescription="Talk about completed past actions with regular and irregular verbs. A2 level exercises and examples."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default SimplePast;

